import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'

function MembersInvalidOneTimeUrlPage(): JSX.Element {
  return (
    <>
      <PageTitle>ご案内</PageTitle>
      <ContentBlock>
        <ContentTitle>ワンタイムURL無効</ContentTitle>
        <ContentTopMessage>
          ワンタイムURLが無効となっています。<br/><br/>
          該当の操作が完了していない方は再度操作をお願いいたします。
        </ContentTopMessage>
      </ContentBlock>
    </>
  )

}

export default MembersInvalidOneTimeUrlPage
